/**
 * Плагин формы профиля
 * @return {jQuery}
 */

(function ($) {
    'use strict';

    $.fn.profileFormEvents = function(options)
    {
        const defaults = {
            restrictDateMin: 5,
            restrictDateMax: 120
        };
        const settings = $.extend({}, defaults, options);
        const $self = $(this);
        const $buttonTogglePassword = $self.find('.js-password-button');
        const $buttonActivatedPrivate = $self.find('.js-private-change-button');
        const $form = $self.find('.js-profile-form-private');

        /**
         * Инициализация плагина
         */
        const init = function()
        {
            initCalendar();
            $form.find('.js-additional-form-data').hide();
            $form.find('.js-fields-password').hide();
            $form.find('.js-reset-change-password').hide();
            $form.find('.js-reset-private').hide();

            $form.on('change', '#password-input-pass1', onInputNewPassword);
            $form.on('input', '#password-input-pass2', onInputNewPassword);

            $form.on('change', '#avatar_upload', onAvatarChange);
            $form.on('click', '.js-change-password-button', onChangePasswordButton);
            $form.on('click', '.js-reset-change-password', onResetChangePasswordButton);
            $form.on('click', '.js-reset-private', onResetPrivateDataButton);
            $buttonTogglePassword.on('click', (event) => {
                togglePasswordVisibility($(event.target).closest($buttonTogglePassword));
            });
            $buttonActivatedPrivate.on('click', onActivatePrivateForm);

            $form.on('submit', onFormSubmit);
        }

        /**
         * Инициализация календаря для даты рождения
         */
        const initCalendar = function()
        {
            const $birthdayInput = $form.find('input[name="bday"]');
            const $calendarToggleBtn = $form.find('.js-title-calendar-wrap');
            const datesRange = getDatesRange();

            $('.js-custom-calendar').inputCalendar($form.find('input[name="bday"]'), datesRange.minDate, datesRange.maxDate);
            $birthdayInput.inputmask({
                alias: 'datetime',
                inputFormat: 'dd.mm.yyyy',
                placeholder: '__.__.____',
                min: datesRange.inputMin,
                max: datesRange.inputMax,
                onincomplete: function() {
                    setFieldError($birthdayInput, 'Введите дату рождения');
                },
                oncomplete: function () {
                    clearFieldError($birthdayInput);
                }
            }).on('input change', function () {
                if ($(this).val().indexOf('_') === -1) {
                    clearFieldError($birthdayInput);
                }
            });
            $calendarToggleBtn.on('click', function () {
                $(this).addClass('active');
            });

            $(document).on('click', function (e) {
                if (!$(e.target).closest('.js-title-calendar-wrap').length) {
                    $calendarToggleBtn.removeClass('active');
                }
            });
        }

        /**
         * Вычисляет минимальную и максимальную даты для инициализации календаря
         * return { {minDate: Date, maxDate: Date, inputMin: string, inputMax: string} }
         */
        const getDatesRange = function()
        {
            const dateNow = new Date();
            const monthNow = String(dateNow.getMonth() + 1).padStart(2, '0'); // <-- исправлено
            const minDate = new Date(`${dateNow.getFullYear() - settings.restrictDateMax}-${monthNow}-01`);
            const maxDate = new Date(`${dateNow.getFullYear() - settings.restrictDateMin}-${monthNow}-01`);
            return {
                minDate,
                maxDate,
                inputMin: `01.${monthNow}.${minDate.getFullYear()}`,
                inputMax: `01.${monthNow}.${maxDate.getFullYear()}`
            }
        }

        /**
         * Показывает ошибки на форме
         * @param {string} field
         * @param {string} message
         */
        const setFieldError = function(field, message)
        {
            const $input = (typeof field === 'object') ? field : $form.find('.js-input[name^="' + field + '"]');

            if ($input.length === 0) {
                return;
            }

            const $wrapper = $input.closest('.js-field');
            const $messageContainer = $wrapper.find('.js-error-text');

            $wrapper.addClass('error');
            $messageContainer.html(message);
            $messageContainer.removeClass('visually-hidden');
        }

        /**
         * Сбрасывает ошибки на форме
         * @param {string} field
         */
        const clearFieldError = function(field)
        {
            const $input = (typeof field === 'object') ? field : $form.find('.js-input[name^="' + field + '"]');

            if ($input.length === 0) {
                return;
            }

            const $wrapper = $input.closest('.js-field');
            const $messageContainer = $wrapper.find('.js-error-text');

            $wrapper.removeClass('error');
            $messageContainer.html('');
            $messageContainer.addClass('visually-hidden');
        }

        /**
         * Проверяет совпадают ли пароли
         * @return {boolean}
         */
        const isMatchedPassword = function()
        {
            return $form.find('#password-input-pass1').val() === $form.find('#password-input-pass2').val()
        }

        /**
         * Переключаем видимость пароля
         */
        const togglePasswordVisibility = function($button)
        {
            const $inputPassword = $button.closest('.js-field').find('.js-password-input');
            const currentType = $inputPassword.attr('type');

            $inputPassword.attr('type', currentType === 'text' ? 'password' : 'text');

            if ($inputPassword.attr('type') === 'password') {
                $button.removeClass('password-visible').addClass('password-hidden');
            } else {
                $button.removeClass('password-hidden').addClass('password-visible');
            }
        };

        /**
         * Обработчик активации формы "Личные данные"
         */
        const onActivatePrivateForm = function()
        {
            $form.find('.js-input').attr('readonly', false);
            $buttonActivatedPrivate.hide();
            $form.find('.js-title-calendar-wrap').removeClass('disabled');

            $.when(
                $form.find('.js-form-note').fadeIn(),
                $form.find('.js-additional-form-data').fadeIn(),
                $form.find('.js-reset-private').fadeIn()
            ).done(function() {
                $form.find('.js-button-submit').attr('disabled', false);
            })
        }

        /**
         * Обработчик клика на кнопку "Изменить пароль"
         * @param {Event} evt
         */
        const onChangePasswordButton = function(evt)
        {
            const $passwordFieldset = $form.find('.js-fields-password');
            if ($passwordFieldset.is(':not(:visible)')) {
                evt.preventDefault();
                $passwordFieldset.fadeIn();
                $form.find('.js-reset-change-password').fadeIn();
            }
        }

        /**
         * Обработчик клика отменить под фиелдсетом "Изменить пароль"
         * @param {Event} evt
         */
        const onResetChangePasswordButton = function(evt)
        {
            evt.preventDefault();
            $form.find('.js-password-input').each(function(i, input) {
                const initialVal = $(input).attr('value');
                $(input).val(initialVal);
                clearFieldError($(input).attr('name'));
            })

            $form.find('.js-fields-password').fadeOut();
            $form.find('.js-reset-change-password').fadeOut();

        }

        /**
         * Обработчик клика отменить под фиелдсетом "Личные данные"
         * @param {Event} evt
         */
        const onResetPrivateDataButton = function(evt)
        {
            evt.preventDefault();
            $form.find('.js-title-calendar-wrap').addClass('disabled');
            $form.find('.js-input:not(.js-password-input)').each(function(i, input) {
                const initialVal = $(input).attr('value');
                $(input).val(initialVal);
                $(input).attr('readonly', true);
                clearFieldError($(input).attr('name'));
            })
            $form.find('.js-button-submit').attr('disabled', true);
            $form.find('.js-private-change-button').fadeIn();
            $form.find('.js-form-note').fadeOut();
            $form.find('.js-additional-form-data').fadeOut();
            $form.find('.js-reset-private').fadeOut();

        }

        /**
         * Обработчик загрузки аватарки
         */
        const onAvatarChange = function()
        {
            $form.submit();
        }

        /**
         * Обработчик ввода в поле нового пароля
         */
        const onInputNewPassword = function()
        {
            if ($form.find('#password-input-pass1').val() && $form.find('#password-input-pass2').val()) {
                const passwordFields = $form.find('#password-input-pass1').add($form.find('#password-input-pass2'));
                if (isMatchedPassword()) {
                    passwordFields.each(function(i, input) {
                        clearFieldError($(input))
                    })
                } else {
                    passwordFields.each(function(i, input) {
                        setFieldError($(input),'Пароли не совпадают')
                    })
                }
            }
        }

        /**
         * Обработчик отправки формы
         * @param {Event} evt
         */
        const onFormSubmit = function (evt)
        {
            evt.preventDefault();
            $.ajax('/ajax/user/profile/update.php', {
                method: 'POST',
                data: $form.serializeArray(),
                dataType: 'json'
            }).done(function (response) {
                if (response.result) {
                    let href = location.href + '?success=1';
                    if (response.hasOwnProperty('isChangeRequested') && response.isChangeRequested) {
                        href += '&request=1';
                    }

                    window.location = href;
                }

                Object.keys(response.errors).forEach((field) => {
                    setFieldError(field, response.errors[field]);
                });
            }).fail((response) => {
                console.error(response);
            });
        }

        init();

        return this;
    }
})(jQuery);
